import React, { useState, useEffect } from 'react';
import { RootState } from '../Redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { setAuth } from '../Redux/authSlice';
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Modal, Button, Card, Breadcrumb, Pagination } from 'react-bootstrap';
import "./customers.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import { translations } from '../utils/translations';
interface Customer {
    id: number;
    name: string;
    email: string;
    phone_number: string;
    address: string;
    date_registered: string;
}

export default function CustomerComponent() {
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [loading, setLoading] = useState<boolean>(false);
    const [userRole, setUserRole] = useState<string | null>(null);
    const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
    const [showEditModal, setShowEditModal] = useState<boolean>(false);
    const [showCreateModal, setShowCreateModal] = useState<boolean>(false);
    const [editName, setEditName] = useState<string>('');
    const [editEmail, setEditEmail] = useState<string>('');
    const [editPhone, setEditPhone] = useState<string>('');
    const [editAddress, setEditAddress] = useState<string>('');
    const [newCustomerName, setNewCustomerName] = useState<string>('');
    const [newEmail, setNewEmail] = useState<string>('');
    const [newPhone, setNewPhone] = useState<string>('');
    const [newAddress, setNewAddress] = useState<string>('');
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [totalPages, setTotalPages] = useState<number>(0);
    const [searchTerm, setSearchTerm] = useState<string>('');
    const [errorMessage, setErrorMessage] = useState(''); // State for error message


    const dispatch = useDispatch();
    const auth = useSelector((state: RootState) => state.auth.value);
    const language = useSelector((state: RootState) => state.language.language);
    const t = translations[language as keyof typeof translations];

    const getCookie = (name: string) => {
        const cookieName = name + "=";
        const decodedCookie = decodeURIComponent(document.cookie);
        const cookieArray = decodedCookie.split(';');
        for (let i = 0; i < cookieArray.length; i++) {
            let cookie = cookieArray[i];
            while (cookie.charAt(0) === ' ') {
                cookie = cookie.substring(1);
            }
            if (cookie.indexOf(cookieName) === 0) {
                return cookie.substring(cookieName.length, cookie.length);
            }
        }
        return '';
    };

    const fetchData = async () => {
        try {
            const token = getCookie('token');
            if (!token) {
                dispatch(setAuth(false));
                return;
            }
            axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
            const userResponse = await axios.get('https://api.sominnovations.xyz/users/user', {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setUserRole(userResponse.data.user.role);
            dispatch(setAuth(true));
        } catch (e) {
            dispatch(setAuth(false));
        }
    };

    const fetchCustomers = async (page: number) => {
        setLoading(true);
        try {
            const response = await axios.get(`https://api.sominnovations.xyz/Branches/customers/?page=${page}&search=${searchTerm}`, {
                headers: {
                    'Content-Type': 'application/json',
                },
            });
            setCustomers(response.data.results);
            setTotalPages(Math.ceil(response.data.count / 20)); // Assuming 20 items per page
        } catch (error) {
            console.error('Error fetching customers:', error);
        }
        setLoading(false);
    };

    useEffect(() => {
        fetchData();
    }, [dispatch]);

    useEffect(() => {
        if (auth) {
            fetchCustomers(currentPage);
        }
    }, [auth, currentPage, searchTerm]); // Add searchTerm to dependencies

    const handleEdit = (customer: Customer) => {
        setSelectedCustomer(customer);
        setEditName(customer.name);
        setEditEmail(customer.email);
        setEditPhone(customer.phone_number);
        setEditAddress(customer.address);
        setShowEditModal(true);
    };

    const handleSaveEdit = async () => {
        if (selectedCustomer) {
            try {
                await axios.put(`https://api.sominnovations.xyz/Branches/customers/${selectedCustomer.id}/`, {
                    name: editName,
                    email: editEmail,
                    phone_number: editPhone,
                    address: editAddress,
                });
                setCustomers(customers.map(customer =>
                    customer.id === selectedCustomer.id
                        ? { ...customer, name: editName, email: editEmail, phone_number: editPhone, address: editAddress }
                        : customer
                ));
                setShowEditModal(false);
            } catch (error) {
                console.error('Error updating customer:', error);
            }
        }
    };

    const handleCreateCustomer = async () => {
        try {
            const response = await axios.post('https://api.sominnovations.xyz/Branches/customers/', {
                name: newCustomerName,
                email: newEmail,
                phone_number: newPhone,
                address: newAddress,
            });
            setCustomers([...customers, response.data]);
            setShowCreateModal(false);
            setNewCustomerName('');
            setNewEmail('');
            setNewPhone('');
            setNewAddress('');
        } catch (error) {
            console.error('Error creating customer:', error);
            setErrorMessage('Customer with this email already exists');
        }
    };

    const handleView = (id: number) => {
        console.log('View customer with ID:', id);
    };

    const handleDelete = async (id: number) => {
        if (window.confirm("Are you sure you want to delete customer?")) {
            try {
                await axios.delete(`https://api.sominnovations.xyz/Branches/customers/${id}/`);
                setCustomers(customers.filter(customer => customer.id !== id));
                console.log('Deleted customer with ID:', id);
            } catch (error) {
                console.error('Error deleting customer:', error);
            }
        }
    };
    return (
        <div className="container mt-1 customers-container">

            <Card className="mb-4">
                <Card.Header style={{ backgroundColor: '#5271ff', color: '#fff' }}>
                    <div className="d-flex justify-content-between align-items-center">
                        <h4>{t.customers}</h4>
                        <Breadcrumb>
                            <Breadcrumb.Item href="dashboard"><p style={{ color: "white" }}>{t.dashboard}</p></Breadcrumb.Item>
                            <Breadcrumb.Item active>{t.customers}</Breadcrumb.Item>
                        </Breadcrumb>
                    </div>
                </Card.Header>
                <Card.Body>
                    <Button variant="warning" onClick={() => setShowCreateModal(true)}>
                        + {t.create} {t.customers}
                    </Button>
                </Card.Body>
            </Card>
            <div className="mb-4">
                <input
                    type="text"
                    className="form-control"
                    placeholder={t.searchCustomer}
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)} // Update search term state
                />
            </div>
            {loading ? (
                <div>Loading...</div>
            ) : (
                <>
                    <div className='table-responsive-sm'>
                        <table className="table table-striped">
                            <thead className="table-dark">
                                <tr>
                                    <th>#</th>
                                    <th>{t.firstName}</th>
                                    <th>{t.email}</th>
                                    <th>{t.phoneNumber}</th>
                                    <th>{t.branchName}</th>
                                    <th>{t.actions}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {customers.map((customer, index) => (
                                    <tr key={customer.id}>
                                        <td>{index + 1 + (currentPage - 1) * 20}</td>
                                        <td>{customer.name}</td>
                                        <td>{customer.email}</td>
                                        <td>{customer.phone_number}</td>
                                        <td>{customer.address}</td>
                                        <td>
                                            {/* <button
                                            className="btn btn-info btn-sm me-2"
                                            onClick={() => handleView(customer.id)}
                                        >
                                            View
                                        </button> */}
                                            <button
                                                className="btn btn-warning btn-sm me-2"
                                                onClick={() => handleEdit(customer)}
                                            >
                                                <FontAwesomeIcon icon={faEdit} />
                                                Edit
                                            </button>
                                            {userRole !== 'accountant' && (
                                                <button
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => handleDelete(customer.id)}
                                                >
                                                    <FontAwesomeIcon icon={faTrashAlt} />
                                                    {t.delete}
                                                </button>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    <Pagination>
                        <Pagination.Prev
                            onClick={() => currentPage > 1 && setCurrentPage(currentPage - 1)}
                            disabled={currentPage === 1}
                        />
                        {Array.from({ length: totalPages }, (_, index) => (
                            <Pagination.Item
                                key={index + 1}
                                active={index + 1 === currentPage}
                                onClick={() => setCurrentPage(index + 1)}
                            >
                                {index + 1}
                            </Pagination.Item>
                        ))}
                        <Pagination.Next
                            onClick={() => currentPage < totalPages && setCurrentPage(currentPage + 1)}
                            disabled={currentPage === totalPages}
                        />
                    </Pagination>
                </>
            )}

            {/* Create Customer Modal */}
            <Modal show={showCreateModal} onHide={() => setShowCreateModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Customer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {errorMessage && <div className="error-text " style={{ color: "red" }}>{errorMessage}</div>}

                    <form>
                        <div className="form-group">
                            <label>Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={newCustomerName}
                                onChange={(e) => setNewCustomerName(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                className="form-control"
                                value={newEmail}
                                onChange={(e) => setNewEmail(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone Number</label>
                            <input
                                type="text"
                                className="form-control"
                                value={newPhone}
                                onChange={(e) => setNewPhone(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Address</label>
                            <input
                                type="text"
                                className="form-control"
                                value={newAddress}
                                onChange={(e) => setNewAddress(e.target.value)}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowCreateModal(false)}>
                        Close
                    </Button>
                    <Button variant="warning" onClick={handleCreateCustomer}>
                        Create
                    </Button>
                </Modal.Footer>
            </Modal>

            {/* Edit Customer Modal */}
            <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>Edit Customer</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <form>
                        <div className="form-group">
                            <label>Name</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editName}
                                onChange={(e) => setEditName(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Email</label>
                            <input
                                type="email"
                                className="form-control"
                                value={editEmail}
                                onChange={(e) => setEditEmail(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Phone Number</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editPhone}
                                onChange={(e) => setEditPhone(e.target.value)}
                            />
                        </div>
                        <div className="form-group">
                            <label>Address</label>
                            <input
                                type="text"
                                className="form-control"
                                value={editAddress}
                                onChange={(e) => setEditAddress(e.target.value)}
                            />
                        </div>
                    </form>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowEditModal(false)}>
                        Close
                    </Button>
                    <Button variant="warning" onClick={handleSaveEdit}>
                        Save Changes
                    </Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
